const nftInitialState = {
  loading: false,
  myNfts: [],
  firstLoad: true,
};

export default nftInitialState;
